// Query params that are credentials, not telemetry. The password-reset oobCode
// arrives in the URL, so anything that records a URL (RUM views and their
// session replays, analytics page_location) would otherwise store a live
// single-use credential.
const SENSITIVE_PARAMS = ['oobCode'];

// The booking manage link carries its access code in the fragment
// (`#code=...`). Fragments are not sent to the server but RUM records the full
// view URL, so a fragment holding a code is dropped entirely.
const FRAGMENT_WITH_CODE = /#(?:[^#]*&)?code=.*$/;

const scrubSensitiveParams = (rawUrl: string): string => {
  const url = rawUrl.replace(FRAGMENT_WITH_CODE, '');
  if (!SENSITIVE_PARAMS.some(param => url.includes(param))) return url;
  try {
    const parsed = new URL(url);
    SENSITIVE_PARAMS.forEach(param => parsed.searchParams.delete(param));
    return parsed.toString();
  } catch {
    // Not a parsable absolute URL: drop the whole query rather than risk
    // leaking it.
    return url.split('?')[0];
  }
};

export default scrubSensitiveParams;
